export default __webpack_public_path__ + "static/media/hmd_l2.d845d6ae.png";